// What waits on 财务管理's review pages, for the menu's counts and the
// pages' heads: read when the console starts and every minute after, and
// again by a review page as soon as it has acted on a document.
import { ref } from 'vue'
import { api, type FinanceSummary } from '@/api/client'

export const financeSummary = ref<FinanceSummary | null>(null)

let timer: ReturnType<typeof setInterval> | undefined

export async function refreshFinance() {
  try {
    financeSummary.value = await api.financeSummary()
  } catch {
    // The counts stay as they were; the pages say what failed.
  }
}

/** Starts the minute's refresh, once. */
export function watchFinance() {
  if (timer) return
  void refreshFinance()
  timer = setInterval(() => void refreshFinance(), 60_000)
}
